import { actionCreators } from 'store/modules/dialogs'
import { dialogTypes } from 'dialogs'

export const confirmMiddleware = store => next => action => {
  if (action.type) {
    const { hasConfirm, confirmMessage } = action
    if (hasConfirm) {
      store.dispatch(
        actionCreators.showDialog({
          dialogType: dialogTypes.confirm,
          context: {
            message: confirmMessage,
            onConfirm: () => next(action)
          }
        })
      )
    } else {
      return next(action)
    }
  } else {
    return next(action)
  }
}
